import React, { useState } from "react";
import { Question } from "../../@types/question.interface";
import "./view-question.styles.scss";
import { TrashOutlineIcon } from "../icons/trash/trash.component";
import { EditOutlineIcon } from "../icons/edit/edit.component";
import DeletePrompt from "../delete-prompt/delete-prompt.component";
import Button from "../button/button.component";
import { useHistory } from "react-router-dom";
import QuestionContent from "../question-content/question-content.component";
import AnswerSheet from "../answer-sheet/answer-sheet.component";
import { Answer } from "../../@types/answer.interface";

interface IProps {
    quizId: number;
    question: Question | null;
    questions: Question[];
    index: number;
    setIndex: (index: number) => void;
    length: number;
    answers?: Answer[];
    handleChange?: (evt: any, questionType: number) => void;
    handleClick: (evt: any, name: string, idx?: number) => void;
    setActiveTab?: (tab: number) => void;
    takeQuiz?: boolean;
}

export default function ViewQuestion({
    quizId,
    question,
    questions,
    index,
    setIndex,
    length,
    answers,
    handleChange,
    handleClick,
    setActiveTab,
    takeQuiz,
}: IProps) {
    const [deleteState, setDeleteState] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<number>(-1);
    const handleDelete = (id: number | undefined) => {
        setDeleteState(true);
        if (id !== undefined) {
            setDeleteId(id);
        }
    };
    const history = useHistory();
    return (
        <div className="view-question">
            {deleteState ? (
                <DeletePrompt
                    quizId={quizId}
                    questionId={deleteId}
                    deleteState={deleteState}
                    setDeleteState={setDeleteState}
                    index={index}
                    setIndex={setIndex}
                    question
                />
            ) : (
                ""
            )}
            <div className="view-question__questions">
                {length <= 0 || question === null ? (
                    takeQuiz ? (
                        <div className="view-question__questions__empty">
                            <span>There is no Question.</span>
                        </div>
                    ) : (
                        <div className="view-question__questions__empty">
                            <span>
                                There is no Question, Please Insert Question !
                            </span>
                            <Button
                                className="dark"
                                onClick={() =>
                                    setActiveTab ? setActiveTab(1) : ""
                                }
                            >
                                Insert Question
                            </Button>
                        </div>
                    )
                ) : (
                    <>
                        <div className="view-question__questions__question">
                            {takeQuiz ? (
                                ""
                            ) : (
                                <div className="view-question__questions__question__action">
                                    <div>
                                        <EditOutlineIcon
                                            onClick={() =>
                                                history.push(
                                                    `/quiz/${quizId}/question/${question.question_number}`
                                                )
                                            }
                                            size={1.8}
                                        />
                                    </div>
                                    <div>
                                        <TrashOutlineIcon
                                            hoverColor="red"
                                            size={1.7}
                                            onClick={() =>
                                                handleDelete(
                                                    question.question_id
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="view-question__questions__question__content">
                                <QuestionContent
                                    question={question}
                                    answer={
                                        answers !== undefined
                                            ? answers[index]
                                            : null
                                    }
                                    handleChange={handleChange}
                                />
                            </div>
                            <div className="view-question__questions__question__buttons">
                                {index + 1 !== 1 ? (
                                    <Button
                                        onClick={(evt) =>
                                            handleClick(evt, "prev")
                                        }
                                        className="left-btn"
                                    >
                                        Previous
                                    </Button>
                                ) : (
                                    ""
                                )}
                                {length > 1 && index + 1 !== length ? (
                                    <Button
                                        onClick={(evt) =>
                                            handleClick(evt, "next")
                                        }
                                        className="right-btn dark"
                                    >
                                        Next
                                    </Button>
                                ) : (
                                    ""
                                )}
                                {index + 1 === length ? (
                                    <Button
                                        className="right-btn red"
                                        onClick={(evt) =>
                                            handleClick(evt, "finish")
                                        }
                                    >
                                        Finish
                                    </Button>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                        {answers ? (
                            <div className="view-question__questions__answer">
                                <AnswerSheet
                                    questions={questions}
                                    answers={answers}
                                    handleClick={handleClick}
                                />
                            </div>
                        ) : (
                            ""
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
